/**
 * The languages Legends speaks, as DATA.
 *
 * The first path segment of every application URL is a LANGUAGE — `/en/garage`
 * — and not a market (CON-002). That is the one deliberate divergence from the
 * sibling product plant.habb.me, whose segment is market-first because its
 * content genuinely differs by country: a hardiness zone and a planting
 * calendar are Austrian or Hungarian facts. A Ferrari F40 made 478 hp in every
 * country that ever imported one. There is no market axis here to carry, so
 * carrying one would be a redirect and a matrix in the switcher bought for
 * nothing (ADR-0002).
 *
 * `endonym` is the language's name in itself and is deliberately NOT a message
 * key: someone who cannot read the language currently on screen still has to be
 * able to find theirs, so these strings never translate.
 *
 * `flagCode` is the nation whose flag stands for the language. English takes
 * the flag of the language's origin.
 *
 * English is the only entry today, and the shape of this file is the whole
 * point of shipping it that way: a second language is a row here plus a
 * catalogue in `messages/`, and nothing in the router, the shell or any screen
 * moves.
 */
export const LANGUAGES = [
    { code: 'en', endonym: 'English', flagCode: 'gb' },
];

/**
 * The language a visitor lands on when nothing about them matches one we ship.
 * They still get a real, complete app rather than a 404 or an empty shell.
 */
export const FALLBACK_LANGUAGE = 'en';

export function findLanguage(languageCode) {
    return LANGUAGES.find((language) => language.code === languageCode) || null;
}

export function listSupportedLanguages() {
    return LANGUAGES.map((language) => language.code);
}
